import { Card, Grid,Typography } from '@material-ui/core';
import { useWallet } from '@solana/wallet-adapter-react';
import { FC, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import BN from 'bn.js';

import Screen from '../../../components/layout/Screen';
import WalletButton from '../../../components/layout/WalletButton';
import Spacer from '../../../components/Spacer';
import { useRafflesStore } from '../../../hooks/useRafflesStore';
import { routes } from '../../../router/routes';
import { useStyles } from './styles';
import CircularProgress from '@material-ui/core/CircularProgress';
const AdminHomeScreen: FC = () => {
  const classes = useStyles();
  const { connected, publicKey } = useWallet();
  const { push } = useHistory();
  const { raffles, fetchAllRaffles, fetching } = useRafflesStore();


  useEffect(() => {
    fetchAllRaffles(true);
  }, [fetchAllRaffles]);

  // console.log(raffles, 'arff')
  return (
    <div className={classes.root + ' relative z-20'}>
      {connected ? (
        <>
          {!fetching && !raffles.size ? (
            <Typography variant="h6">
              You haven't created any raffles
            </Typography>
          ) : (
            <>
              <p className="text-white text-center text-xl">My raffles</p>
              <Spacer height={'20px'} />
              {!fetching ? (
                <div className="w-full">
                  {[...raffles.values()]
                    .filter(
                      (raffle) =>
                        raffle.creator.toBase58() === publicKey?.toBase58()
                    )
                    .sort(
                      (raffle1, raffle2) =>
                        raffle2.endTimestamp.getTime() -
                        raffle1.endTimestamp.getTime()
                    )
                    // .filter((raffle) => raffle.prizes[0])
                    .map((raffle) => (
                      <div
                        className="w-full mb-2"
                        key={raffle.publicKey.toBase58()}
                      >
                        <div
                          className={
                            raffle.proceedsCollected
                              ? ' px-4 py-2 cursor-pointer border bg-brand_smooth_gray items-center flex justify-between w-full bg-brand_gray'
                              : ' px-4 py-2 cursor-pointer border items-center flex justify-between w-full bg-brand_gray'
                          }
                          onClick={() =>
                            push(
                              `${routes.DASHBOARD.RAFFLES}/${raffle.publicKey}`
                            )
                          }
                        >
                          <div className="flex items-center">
                            <div className="pr-6">
                              {raffle.prizes[0]?.meta?.imageUri ? (
                                <img
                                  width="50px"
                                  height="50px"
                                  src={raffle.prizes[0]?.meta?.imageUri}
                                  alt={raffle.prizes[0]?.meta?.name}
                                />
                              ) : (
                                <div
                                  style={{ width: '50px', height: '50px' }}
                                  className="text-center bg-gray-500 flex items-center justify-center"
                                >
                                  IR
                                </div>
                              )}
                            </div>
                            <p className="text-white">
                              {
                                //@ts-ignore
                                raffle.prizes[0]?.meta?.name || 'Invalid Raffle'
                              }
                            </p>
                          </div>
                          <p className="text-white">
                            {
                              //@ts-ignore
                              raffle.isEnded ? ' ENDED ' : ' LIVE '
                            }
                          </p>
                        </div>
                      </div>
                    ))}
                </div>
              ) : (
                <CircularProgress color="secondary" />
              )}
              <Spacer height={'50px'} />
            </>
          )}
        </>
      ) : (
        <>
          <p className="GTWalsheimProBold text-white">
            CONNECT WITH WALLET TO UNLOCK ADMIN PANEL
          </p>
          <div className={classes.walletButtonContainer}>
            <WalletButton />
          </div>
        </>
      )}
    </div>
  );
};

const AdminHomeScreenWithLayout = () => (
  <Screen>
    <AdminHomeScreen />
  </Screen>
);

export default AdminHomeScreenWithLayout;
